import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import styled from 'styled-components';
import { disposeEditorMapViewer, getEditorMapViewer, createEditorMapViewer } from '../../canvas/editor/EditorMapViewer';
const Container = styled.div.withConfig({
  displayName: "MapViewerContainer__Container",
  componentId: "sc-14opbt5-0"
})(["height:100%;"]); // This is a class-based component to have proper mounting/dismounting with hot reloading.
// See the comment in GameContainer.tsx for more details.

export class MapViewerContainer extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "refElement", void 0);
  }

  componentDidMount() {
    createEditorMapViewer();
    getEditorMapViewer().attach(this.refElement);
  }

  componentWillUnmount() {
    disposeEditorMapViewer();
  }

  render() {
    return /*#__PURE__*/React.createElement(Container, {
      ref: ref => {
        this.refElement = ref;
        const editorMapViewer = getEditorMapViewer();
        if (!editorMapViewer) return;

        if (ref) {
          editorMapViewer.attach(ref);
        } else {
          editorMapViewer.detach();
        }
      }
    });
  }

}
/*
export const MapViewerContainer: React.FunctionComponent = () => {
    const mapViewerDivRef = usePixiApp(createEditorMapViewer, getEditorMapViewer, disposeEditorMapViewer);

    return (
        <Container ref={mapViewerDivRef} />
    );
};
*/